<template>
    <div>
        <app-header></app-header>
        <div class="text-center">
            <router-link to="/garments/all">
                <img style="width:100%" src="../../../static/images/2024/Customised_Clothing_Headers-01.png" alt="" />
            </router-link>
        </div>
        <div class="bg--lilac pad-top pad-bottom--xxl">
            <div class="show-for-small-only grid-x grid-padding-x">
                <div class="cell small-6">
                    <router-link
                        tag="button"
                        to="/order/design"
                        class="button expanded green tall">
                        Customise Now
                    </router-link>
                </div>
                <div class="cell small-6">
                    <router-link
                        tag="button"
                        to="/garments/all"
                        class="button expanded tall">
                        Shop Now
                    </router-link>
                </div>
            </div>
            <div class="card-wrap">
                <div class="grid-x grid-margin-x">
                    <div class="cell small-12 medium-3 card pad--xs">
                        <p class="text-center pad-top--large pad-bottom">
                            <img class="icons-shipping" src="../../../static/images/icons/shipped.png" alt="" />
                        </p>
                        <h4 class="text-heavy text-center text-blue">FREE DELIVERY</h4>
                        <p class="text-center pad-bottom">on all orders over £99</p>
                    </div>
                    <div class="cell small-12 medium-3 card pad--xs">
                        <p class="text-center pad-top--large pad-bottom">
                            <img class="icons-dollar" src="../../../static/images/icons/dollar.png" alt="" />
                        </p>
                        <h4 class="text-heavy text-center text-blue">NO MINIMUM ORDER</h4>
                        <p class="text-center pad-bottom">we accept orders of any size</p>
                    </div>
                    <div class="cell small-12 medium-3 card pad--xs">
                        <p class="text-center pad-top--large pad-bottom">
                            <img class="icons-trolley" src="../../../static/images/icons/trolley.png" alt="" />
                        </p>
                        <h4 class="text-heavy text-center text-blue">EXPRESS SERVICE</h4>
                        <p class="text-center pad-bottom">delivery within 3 days</p>
                    </div>
                    <div class="cell small-12 medium-3 card pad--xs">
                        <p class="text-center pad-top--large pad-bottom">
                            <img class="icons-discount" src="../../../static/images/icons/discount.png" alt="" />
                        </p>
                        <h4 class="text-heavy text-center text-blue">PRICE MATCH PROMISE</h4>
                        <p class="text-center pad-bottom">we'll beat any like for like quote<sup>*</sup></p>
                    </div>
                </div>
                <div class="grid-x grid-margin-x">
                    <div class="cell small-12">
                        <h2>CATEGORY</h2>
                    </div>
                </div>
                <div class="grid-x grid-margin-x">
                    <div class="cell small-5">
                        <router-link to="/garments/tshirts">
                            <img src="../../../static/images/2024/Customised_Clothing_Headers-04.png" />
                        </router-link>
                    </div>
                    <div class="cell small-7">
                        <div class="grid-x grid-margin-x">
                            <div class="cell small-4 pad--xs">
                                <router-link to="/garments/hoodies">
                                    <img src="../../../static/images/2024/Customised_Clothing_Headers-05.png" />
                                </router-link>
                            </div>
                            <div class="cell small-4 pad--xs">
                                <router-link to="/garments/jackets">
                                    <img src="../../../static/images/2024/Customised_Clothing_Headers-06.png" />
                                </router-link>
                            </div>
                            <div class="cell small-4 pad--xs">
                                <router-link to="/garments/bodywarmers">
                                    <img src="../../../static/images/2024/Customised_Clothing_Headers-07.png" />
                                </router-link>
                            </div>
                        </div>
                        <div class="grid-x grid-margin-x">
                            <div class="cell small-4 pad--xs">
                                <router-link to="/garments/fleeces">
                                    <img src="../../../static/images/2024/Customised_Clothing_Headers-08.png" />
                                </router-link>
                            </div>
                            <div class="cell small-4 pad--xs">
                                <router-link to="/garments/poloshirts">
                                    <img src="../../../static/images/2024/Customised_Clothing_Headers-09.png" />
                                </router-link>
                            </div>
                            <div class="cell small-4 pad--xs">
                                <router-link to="/garments/all">
                                    <img src="../../../static/images/2024/Customised_Clothing_Headers-10.png" />
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid-x">
            <div class="cell small-12 medium-6 pad">
                <h1>Customised Clothing – We supply personalised clothing to businesses and individuals</h1>
                <p>
                    Customised Clothing - the UK’s leading service provider of <a href="https://customisedclothing.com/garments/all">custom clothing</a>, <a href="https://customisedclothing.com/embroidery-service">embroidered merchandise</a>, <a href="https://customisedclothing.com/garments/tshirts">printed t-shirts</a>, <a href="https://customisedclothing.com/garments/hoodies">hoodies</a>, <a href="https://customisedclothing.com/garments/poloshirts">polo shirts</a> and more. From our Leicester based headquarters we can supply and distribute branded personalised clothing both within the UK and all over the world.
                </p>
                <p>
                    We create personalised clothing to suit any event whether it’s <a href="https://customisedclothing.com/garments/poloshirts">embroidered polo shirts</a> with your company logo or a run of <a href="https://customisedclothing.com/garments/tshirts">bulk printed t-shirts</a> for an event, with overnight shipping and next day delivery rest assured you are in capable hands. Our in-house <a href="https://customisedclothing.com/order/design">design</a> and production facility is capable of branding and <a href="https://customisedclothing.com/garment-finishing-relabeling">relabelling</a> over 20,000 t-shirts a day!
                </p>
                <p>
                    We supply <a href="https://customisedclothing.com/workwear">embroidered workwear</a>, <a href="https://customisedclothing.com/sectors/corporatewear">personalised business clothing</a>, custom embroidered clothing to businesses, <a href="https://customisedclothing.com/sectors/schoolanduniversity">schools</a>, charities, printers, universities and the <a href="https://customisedclothing.com/sectors/healthcare">healthcare sector</a> all through our online ordering portal and easy to use <a href="https://customisedclothing.com/order/design">design tool</a>! We don’t just stop there, we personalise clothes for both business and individuals so whether you are an enterprise business or starting a t-shirt business, we have got you covered. Customise your clothes now!
                </p>
                <p>
                    Personalised clothing:
                </p>
                <p>
                    What better way to personalise clothing than with print and embroidery. Our in house specialists are here to help you through the process. We have over 30 years’ experience producing customised printing, printed clothing and embroidered merchandise so rest assured you are in good hands.
                </p>
                <p>
                    For all of your high quality <a href="https://customisedclothing.com/garments/all">custom clothing</a> requirements with no minimum orders or to hear more about how we can add a personalised touch to your clothing get in touch with one of our experts today and make your imagination come alive with Customised Clothing.
                </p>
            </div>
            <div class="cell small-12 medium-6">
                <img style="width:100%" src="../../../static/images/home-screen-print-image.jpg" alt="" />
            </div>
        </div>

        <div class="grid-x">
            <!-- style="margin-top: -14px;" in below div if it gets swapped back -->
            <div

                class="cell small-12 medium-6 bg--img bg--img-one wash pad-top--xxl pad-bottom--xl">
                <div class="grid-x grid-padding-x z-up">
                    <div class="cell small-12 pad-top--xxl">
                        <h3 class="text-white pad-top--xxl">Why choose us?</h3>
                        <p class="lead text-white">
                            Customer Satisfaction Guaranteed<br />
                            Quality &amp; Commitment to Excellence<br />
                            In-House Design &amp; Production<br />
                            Ethical, Environmentally Focused &amp; Responsible Supply Chain<br />
                            Technologically Driven<br />
                        </p>
                        <p class="clear pad-top">
                            <router-link to="/why-choose-us" tag="button" class="plus-button">
                                <i class="material-icons text-white">add_circle</i>More
                            </router-link>
                        </p>
                    </div>
                </div>
            </div>
            <div class="cell small-12 medium-6">
                <div class="pad">
                    <div class="grid-x grid-padding-x">
                        <div class="cell small-12 pad-top--xl">
                            <h3 class="text-blue">
                                Brands That Trust Us
                            </h3>
                        </div>
                    </div>
                    <div class="grid-x grid-padding-x pad-top">
                        <div class="cell small-4">
                            <img width="100%" src="../../../static/images/brands-that-trust-us/barclays.png" alt="" />
                        </div>
                        <div class="cell small-4">
                            <img width="100%" src="../../../static/images/brands-that-trust-us/bbc.png" alt="" />
                        </div>
                        <div class="cell small-4">
                            <img width="100%" src="../../../static/images/brands-that-trust-us/bentley.png" alt="" />
                        </div>
                    </div>
                    <div class="grid-x grid-padding-x pad-top--xxl">
                        <div class="cell small-4">
                            <img width="100%" src="../../../static/images/brands-that-trust-us/british-airways.png" alt="" />
                        </div>
                        <div class="cell small-4">
                            <img width="100%" src="../../../static/images/brands-that-trust-us/british-gas.png" alt="" />
                        </div>
                        <div class="cell small-4">
                            <img width="100%" src="../../../static/images/brands-that-trust-us/google.png" alt="" />
                        </div>
                    </div>
                    <div class="grid-x grid-padding-x pad-top">
                        <div class="cell small-12">
                            <p class="text-right">
                                <router-link to="/brands-that-trust-us">See all brands</router-link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top pad-bottom">
            <div class="cell small-12 medium-8 medium-offset-2">
                <div class="video-container">
                    <iframe src="https://www.youtube.com/embed/qkIvYzbAWQI" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>
        </div>
        <img width="100%" src="../../../static/images/step1.png" alt="" />
        <img width="100%" src="../../../static/images/step2.png" alt="" />
        <img width="100%" src="../../../static/images/step3.png" alt="" />
        <img width="100%" src="../../../static/images/step4.png" alt="" />
        <div class="relative">
            <h3 class="top-center lozenge bg--lilac text-blue">Customisation</h3>
            <div class="grid-x">
                <div class="cell small-12 medium-6 pad-top--xxxxl bg--img bg--embroidery wash">
                    <div class="pad z-up">
                        <h3 class="text-right text-white">Embroidery</h3>
                        <p class="text-right text-white pad-left--xl">
                            your logo is stitched out by specialist machinery onto your<br />
                            garment of choice. A very durable and professional<br />look and feel
                        </p>
                        <p class="text-right pad-top">
                            <router-link
                                to="/order/design"
                                class="plus-button">
                                <i class="material-icons text-white">add_circle</i>
                                More
                            </router-link>
                        </p>
                    </div>
                </div>
                <div class="cell small-12 medium-6 pad-top--xxxxl bg--img bg--print wash">
                    <div class="pad z-up">
                        <h3 class="text-white">Print</h3>
                        <p class="text-white pad-right--xl">
                            we use various methods to apply your customisation to your garments, be<br />
                            it screen print, heat transfer or direct to garment print (DTG) we choose<br />
                            the best method for you
                        </p>
                        <p class="pad-top">
                            <router-link
                                to="/order/design"
                                class="plus-button">
                                <i class="material-icons text-white">add_circle</i>
                                More
                            </router-link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg--gradient pad-top pad-bottom">
            <div class="grid-x grid-padding-x">
                <div class="cell small-12 medium-6 medium-offset-2">
                    <h3 class="text-white">Start creating now</h3>
                    <p class="text-white">
                        Place an order in four simple steps
                    </p>
                </div>
                <div class="cell small-12 medium-3 pad-top">
                    <button class="button white tall">Start creating</button>
                </div>
            </div>
        </div>
        <div class="bg--gradient-dark">
            <div class="grid-x grid-padding-x">
                <div class="cell small-12 medium-5 medium-offset-1">
                    <img src="../../../static/images/bulk-order.png" alt="" />
                </div>
                <div class="cell small-12 medium-6">
                    <div class="pad-right--xxxxl">
                        <h3 class="text-white pad-top text-right">Bulk order</h3>
                        <h5 class="text-heavy text-right text-light-blue">Contact us for large enquiries</h5>
                        <ul class="bulk-contact-list">
                            <li class="mail">
                                <a
                                    class="text-white"
                                    href="mailto:sales@customisedclothing.com">
                                    Mail
                                </a>
                            </li>
                            <li class="phone">
                                <a
                                    class="text-white"
                                    href="tel:441164670260">
                                    Call
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg--img wash heavy bg--home-stats">
            <div class="grid-x grid-padding-x z-up pad-top pad-bottom">
                <div class="cell small-12 medium-4">
                    <p class="text-center">
                        <img src="../../../static/images/product-number.png" alt="" />
                    </p>
                    <p class="text-white text-center">Number of products</p>
                    <h4 class="text-white text-center">4,455</h4>
                </div>
                <div class="cell small-12 medium-4">
                    <p class="text-center">
                        <img src="../../../static/images/customisation-number.png" alt="" />
                    </p>
                    <p class="text-white text-center">Number of customisations to date</p>
                    <h4 class="text-white text-center">23,443</h4>
                </div>
                <div class="cell small-12 medium-4">
                    <p class="text-center">
                        <img src="../../../static/images/satisfaction-number.png" alt="" />
                    </p>
                    <p class="text-white text-center">Satisfaction rate</p>
                    <h4 class="text-white text-center">96%</h4>
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12">
                <h3 class="text-center text-blue pad-top--xl pad-bottom--small">What customers say...</h3>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-bottom--xl">
            <div class="cell small-12 medium-6">
                <p class="text-center">
                    <img src="../../../static/images/feedback-1.png" alt="" />
                </p>
                <h5 class="text-center">
                    Albert Parker / London
                </h5>
                <p class="text-center pad-left pad-right">
                    The Customised Clothing website was very easy to use, I placed my order online
                    and actually received it a day earlier than expected. Great quality clothing
                    and service! I would highly recommend.
                </p>
                <p class="text-center">
                    <img src="../../../static/images/stars.png" alt="" />
                </p>
            </div>
            <div class="cell small-12 medium-6">
                <p class="text-center">
                    <img src="../../../static/images/feedback-2.png" alt="" />
                </p>
                <h5 class="text-center">
                    Tom Pollas / Germany
                </h5>
                <p class="text-center pad-left pad-right">
                    I had an urgent requirement for some printed t-shirts for an event, Customised
                    Clothing delivered the t-shirts on time and the quality of print was fantastic.
                    I will definitely be ordering from them again.
                </p>
                <p class="text-center">
                    <img src="../../../static/images/stars.png" alt="" />
                </p>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';

export default {
    name: 'Home',
    metaInfo() {
        return {
            title: 'Custom Clothing UK | Printing & Embroidery | Customised Clothing',
            titleTemplate: '%s',
            meta: [
                { description: 'Discover top-quality custom apparel & personalised clothing from the UK\'s leading supplier, Customised Clothing. Elevate your style with hi vis apparel tailored to your preferences.' },
            ],
            link: [
                { rel: 'canonical', href: 'https://customisedclothing.com/' },
            ],
        };
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Home.vue